import React from 'react';
import { Control } from 'react-hook-form';
import { Box, IconButton } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useBasePromptModal } from '../../contexts/BasePromptModalContext';
import StandardTextField from '../forms/StandardTextField';
import { FieldWithPromptKeyType } from '../forms/FieldTypes';

/**
 * Renders an Append field with an "i" button that opens the singleton base-prompt modal.
 * Passes append key (from fieldName); modal shows override or default for that key.
 */
const InstructionFieldWithPromptModel = ({
  control,
  fieldName,
  field,
  readOnly,
}: {
  control: Control;
  fieldName: string;
  field: FieldWithPromptKeyType;
  readOnly: boolean | undefined;
}) => {
  const { openModal } = useBasePromptModal();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 0.5,
        width: '100%',
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <StandardTextField
          control={control}
          fieldName={fieldName}
          field={field}
          readOnly={readOnly}
        />
      </Box>
      {field.promptKey && (
        <IconButton
          size="small"
          aria-label="View base prompt"
          onClick={() => openModal(field.promptKey)}
          sx={{ p: 0.5, mt: 1 }}
        >
          <InfoOutlined fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default InstructionFieldWithPromptModel;
